<form *ngIf="workerFileFormGroup" [formGroup]="workerFileFormGroup">
  <div class="grid">
     
    <div class="col-12" *ngIf="!workerFile.fileId">
        <p-fileUpload mode="basic" chooseIcon="pi pi-upload" (onSelect)="onFileSelect($event)"
            chooseLabel="Seleccionar fichero" />
    </div>
    
    <div class="col-12 input-field">
        <label for="name">Tipo de fichero</label>
        <p-dropdown formControlName="workerFileTypeId" [options]="workerFileTypes"
            optionLabel="name" optionValue="id" appendTo="body" filterBy="name"  showClear
            placeholder="Fichero genérico" (onChange)="typeChange()" d-form-field-error></p-dropdown>        
    </div>
    <div class="col-9 input-field" >
        <label for="name">Nombre</label>
        <input formControlName="name" id="name" pInputText d-form-field-error />
    </div>
    <div class="col-3 input-field">
        <label for="expirationDate">Fecha de vencimiento</label>
        <p-calendar [firstDayOfWeek]="1" formControlName="expirationDate" [showIcon]="true" [showButtonBar]="true" [monthNavigator]="true"
            [yearNavigator]="true" dateFormat="dd/mm/yy" d-form-field-error appendTo="body" ></p-calendar>
    </div>
      <div class="col-12 input-field">
          <label for="notes">Notas</label>
          <textarea formControlName="notes" pInputTextarea rows="5" d-form-field-error></textarea>
      </div>
      
  </div>
  <div class=" mt-4 flex gap-2 justify-content-end">
      <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary" (click)="cancel()"></p-button>
      <p-button label="Guardar" *ngIf="allowWrite" icon="pi pi-check" styleClass="p-ml-2" (click)="save()"></p-button>
  </div>
</form>
<p-confirmDialog></p-confirmDialog>